export default "__VITE_ASSET__C3sOY8MH__"